import React from "react"

export type FilterToggleButtonProps = {
  id: string
  active: boolean
  onToggle: () => void
  label: string
  small?: boolean
  style?: React.CSSProperties
}

export const FilterToggleButton: React.FC<FilterToggleButtonProps> = ({
  id,
  active,
  onToggle,
  label,
  small = true,
  style,
}) => {
  return (
    <>
      <input
        type="checkbox"
        className="btn-check"
        id={id}
        autoComplete="off"
        checked={active}
        onChange={onToggle}
      />
      <label
        className={`btn ${small ? "btn-sm " : ""}${active ? "btn-primary" : "btn-outline-secondary"}`}
        htmlFor={id}
        style={style}
      >
        {label}
      </label>
    </>
  )
}
